import {setStore, getStore, removeStore} from '@/util/store'
import {validatenull} from "@/util/validate"
import website from '@/const/website'

const tagWel = website.fistPage;
const tagObj = {
  label: '', //标题名称
  value: '', //标题的路径
  query: '' //标题的参数
}
const navs = {
  state: {
    tagList: getStore({name: 'tagList'}) || [],
    tag: getStore({name: 'tag'}) || tagObj,
    tagWel: tagWel,
    tagCurrent: getStore({name: 'tagCurrent'}) || [],
    iframeList: getStore({name: 'iframeList'}) || [],
  },
  actions: {},
  mutations: {
    ADD_TAG: (state, action) => {
      state.tag = action;
      setStore({name: 'tag', content: state.tag, type: 'session'})
      if (!state.tagList.some(a => a.value === action.value)) {
        state.tagList.push({
          label: action.label,
          value: action.value,
          query: action.query,
        })
        setStore({name: 'tagList', content: state.tagList, type: 'session'})
      }
      if (!state.iframeList.some(a => a.value === action.value) && action.iframe === true) {
        state.iframeList.push({
          label: action.label,
          value: action.value,
          query: action.query,
          show: true,
          enable: true
        })
      }
      state.iframeList.forEach((ele, num) => {
        if (ele.value === action.value) {
          ele.show = true
          ele.enable = true
        }
        else {
          ele.show = false
        }
      });
      setStore({name: 'iframeList', content: state.iframeList, type: 'session'})
    },
    SET_TAG_CURRENT: (state, tagCurrent) => {
      state.tagCurrent = tagCurrent;
      setStore({name: 'tagCurrent', content: state.tagCurrent, type: 'session'})
    },
    SET_TAG: (state, value) => {
      state.tagList.forEach((ele, num) => {
        if (ele.value === value) {
          state.tag = state.tagList[num];
          setStore({name: 'tag', content: state.tag, type: 'session'})
        }
      });
    },
    DEL_ALL_TAG: (state, action) => {
      state.tag = state.tagWel;
      state.tagList = [];
      state.tagList.push(state.tagWel);
      setStore({name: 'tag', content: state.tag, type: 'session'})
      setStore({name: 'tagList', content: state.tagList, type: 'session'})
      state.iframeList = [];
      removeStore({name: 'iframeList'});
    },
    DEL_TAG_OTHER: (state, action) => {
      state.tagList.forEach((ele, num) => {
        if (ele.value === state.tag.value) {
          state.tagList = state.tagList.slice(num, num + 1)
          state.tag = state.tagList[0];
          if (state.tag.label != '首页') {
            state.tagList.unshift(state.tagWel);
          }
          setStore({name: 'tag', content: state.tag, type: 'session'})
          setStore({name: 'tagList', content: state.tagList, type: 'session'})
        }
      })
      state.iframeList.forEach((ele, num) => {
        if (ele.value !== state.tag.value) {
          ele.enable = false
        }
      })
      if (state.iframeList.some(a => a.enable === true)) {
        setStore({name: 'iframeList', content: state.iframeList, type: 'session'})
      }
      else {
        state.iframeList = [];
        removeStore({name: 'iframeList'});
      }
    },
    DEL_TAG: (state, action) => {
      state.tagList.forEach((ele, num) => {
        if (ele.value === action.value) {
          state.tagList.splice(num, 1)
          setStore({name: 'tag', content: state.tag, type: 'session'})
          setStore({name: 'tagList', content: state.tagList, type: 'session'})
        }
      })
      state.iframeList.forEach((ele, num) => {
        if (ele.value === action.value) {
          ele.enable = false
        }
      })
      if (state.iframeList.some(a => a.enable === true)) {
        setStore({name: 'iframeList', content: state.iframeList, type: 'session'})
      }
      else {
        state.iframeList = [];
        removeStore({name: 'iframeList'});
      }
    }
  }
}
export default navs



// WEBPACK FOOTER //
// ./src/store/modules/tags.js